import React, { useEffect, useState } from "react";
import styles from "../../common/archive/AdvancedSearch.module.scss";
import AdvancedSearchButton from "../../common/archive/AdvancedSearchButton";
import AdvancedSearchTermInput from "../../common/archive/AdvancedSearchTermInput";
import ArchiveModal from "../../common/archive/ArchiveModal";
import DBSearchWidget from "../person-db/DBSearchWidget";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import { TermType } from "../../utils/useTerm";

type Props = {
  keywordParam: string;
  gameParams: Array<string>;
  gameOptions: Array<string>;
  clearSearch: () => void;
  searchHandler: (params: Array<SearchParam>) => void;
};
const AdvancedSearchTeam: React.FC<Props> = ({
  keywordParam,
  gameParams,
  gameOptions,
  clearSearch,
  searchHandler,
}) => {
  const [isModalShown, setIsModalShown] = useState<boolean>(false);

  const [inputKeyword, setInputKeyword] = useState<string>(keywordParam);
  const [selectedGames, setSelectedGames] = useState<Array<string>>(gameParams);

  // ヘッダーメニューから1ページ目に戻った場合リセットする
  useEffect(() => {
    setInputKeyword(keywordParam);
  }, [keywordParam]);

  useEffect(() => {
    setSelectedGames(gameParams);
  }, [gameParams]);

  const handleAddTag = (field: string, value: string) => {
    switch (field) {
      case "games":
        setSelectedGames([...selectedGames, value]);
        break;
      default:
        break;
    }
  };

  const handleRemoveTag = (field: string, index: number) => {
    switch (field) {
      case "games":
        setSelectedGames(
          selectedGames.filter((game) => game !== selectedGames[index])
        );
        break;
      default:
        break;
    }
  };

  const calcSearchConditionCount = () => {
    let num = selectedGames.length;

    if (inputKeyword && inputKeyword !== "") {
      num++;
    }

    return num;
  };

  const handleSearch = () => {
    searchHandler([
      { field: TermType.Games, value: selectedGames },
      { field: "s", value: inputKeyword },
    ]);

    setModal(false);
  };

  const setModal = (value: boolean) => {
    const html = document.querySelector("html");
    if (html) {
      html.style.overflowY = value ? "hidden" : "unset";
    }

    setIsModalShown(value);
  };

  useEffect(() => {
    return () => {
      const html = document.querySelector("html");
      if (html) {
        html.style.overflowY = "unset";
      }
    };
  }, []);

  return (
    <>
      <AdvancedSearchButton
        openModal={() => setModal(true)}
        searchConditionCount={calcSearchConditionCount()}
      />
      <ArchiveModal isOpen={isModalShown} handleClose={() => setModal(false)}>
        <div className={styles["c-advanced-search"]}>
          <AdvancedSearchTermInput
            handleChange={handleAddTag}
            handleRemove={handleRemoveTag}
            options={gameOptions}
            selectedTerms={selectedGames}
            id={"game-input"}
            field={"games"}
            label={"Game: "}
            placeholder={"ゲームで絞り込む"}
          />
        </div>
        <DBSearchWidget
          keyword={inputKeyword}
          handleSearch={handleSearch}
          handleClear={() => {
            clearSearch();
            setModal(false);
          }}
          handleChange={(value: string) => {
            setInputKeyword(value);
          }}
        />
      </ArchiveModal>
    </>
  );
};

export default AdvancedSearchTeam;
